import { render } from "./colorpicker.vue?vue&type=template&id=6929c3ed"
import script from "./colorpicker.vue?vue&type=script&lang=js"
export * from "./colorpicker.vue?vue&type=script&lang=js"

import "./colorpicker.vue?vue&type=style&index=0&id=6929c3ed&lang=css"

import exportComponent from "E:\\newwww\\shared_space\\shared_store\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__